var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlogNews = function SvgBlogNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 76,
    fill: "none",
    viewBox: "0 0 121 76"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2229_10260",
    width: 121,
    height: 76,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 76,
    x: 0.5,
    fill: "#D9D9D9",
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2229_10260)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2229_10260)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54DCA0",
    d: "M120.5 0H0.5V76H120.5V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M35.5 53.1V14.7C35.5 13.2 36.7 12 38.2 12H98.9C100.4 12 101.6 13.2 101.6 14.7V53.1C101.6 54.6 100.4 55.8 98.9 55.8H38.2C36.7 55.8 35.5 54.6 35.5 53.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M72.2 26.1016H42.4V28.1016H72.2V26.1016Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M72.1999 33.2031H63.2V35.2031H72.1999V33.2031Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M72.1999 40.3008H63.2V42.3008H72.1999V40.3008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M94.6999 47.5H63.2V49.5H94.6999V47.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M91.1 44.1016H80.1C78.2 44.1016 76.6 42.5016 76.6 40.6016V29.6016C76.6 27.7016 78.2 26.1016 80.1 26.1016H91.1C93 26.1016 94.6 27.7016 94.6 29.6016V40.6016C94.6 42.5016 93.1 44.1016 91.1 44.1016ZM80.1 28.1016C79.3 28.1016 78.6 28.8016 78.6 29.6016V40.6016C78.6 41.4016 79.3 42.1016 80.1 42.1016H91.1C91.9 42.1016 92.6 41.4016 92.6 40.6016V29.6016C92.6 28.8016 91.9 28.1016 91.1 28.1016H80.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M98.9 11H38.2C36.1 11 34.5 12.7 34.5 14.7V53.1C34.5 55.2 36.2 56.8 38.2 56.8H98.9C101 56.8 102.6 55.1 102.6 53.1V14.7C102.7 12.7 101 11 98.9 11ZM54 15.6C54 16.4 53.4 17 52.6 17H43.5C42.7 17 42.1 16.4 42.1 15.6C42.1 14.8 42.7 14.2 43.5 14.2H52.7C53.4 14.2 54 14.8 54 15.6ZM39.1 14.2C39.9 14.2 40.5 14.8 40.5 15.6C40.5 16.4 39.9 17 39.1 17C38.3 17 37.7 16.4 37.7 15.6C37.7 14.8 38.3 14.2 39.1 14.2ZM98.9 54.8H38.2C37.2 54.8 36.5 54 36.5 53.1L36.4 19.1C36.7 19.1 37 19.1 37.3 19.1H99.8C100.1 19.1 100.2 19.1 100.6 19.1V53.1C100.7 54.1 99.9 54.8 98.9 54.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M56 33.8008H22.1C20.6 33.8008 19.3 35.0008 19.3 36.4008V58.6008C19.3 60.0008 20.5 61.2008 22.1 61.2008H25.4H27.1L25.9 67.2008L37.9 61.2008H56C57.5 61.2008 58.8 60.0008 58.8 58.6008V36.4008C58.8 35.0008 57.5 33.8008 56 33.8008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M56 32.8008H22.1C20 32.8008 18.3 34.4008 18.3 36.4008V58.6008C18.3 60.6008 20 62.2008 22.1 62.2008H25.8L24.5 69.0008L38.1 62.2008H56C58.1 62.2008 59.8 60.6008 59.8 58.6008V36.4008C59.8 34.4008 58.1 32.8008 56 32.8008ZM57.8 58.6008C57.8 59.5008 57 60.2008 56 60.2008H37.6L27.2 65.4008L28.2 60.2008H22C21 60.2008 20.2 59.5008 20.2 58.6008V36.4008C20.2 35.5008 21 34.8008 22 34.8008H55.8C56.8 34.8008 57.6 35.5008 57.6 36.4008V58.6008H57.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M52.7 40.1992H25.4V42.1992H52.7V40.1992Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M52.7 46.3008H25.4V48.3008H52.7V46.3008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M52.7 52.5H25.4V54.5H52.7V52.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2229_10260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 76,
    x: 0.5,
    fill: "white",
    rx: 8
  })))));
};
export default SvgBlogNews;